import _ from 'underscore';
import { Component } from 'react';
import styled from 'styled-components';
import AcademiesApi from '~/agent/academies';
import StringUtils from '~/common/string-utils';
import isFeatureEnabled from '~/components/common/is-feature-enabled';
import AssetPickerTypes from '~/components/common/asset-picker/asset-picker-types';
import { WRModals } from '~/components/wr-modals/wr-modals-container';
import EcommerceUtils from '~/clc/features/academy-ecommerce/utils/ecommerce-utils';
import Dropdown from '../../widget/dropdown';
import EditSegmentVisibilityModal from '../admin/common/edit-segment-visibility-modal';
import AcademyCertification from '../../../clc/features/academies/utils/academy-certification';
import EditCardBannerModal from '../../common/edit-card-banner-modal';
import { apiPut, showLoader, hideLoader, handleApiError, MixPanel } from '../../../common';
import AcademyThemeContentCard from './academy-theme-content-card';
import AwardedAcademyCertificationModal from './awarded-academy-certification-modal';

class AcademyCertificationCard extends Component {
  TRANSLATED_COMPLETED = I18n.t('js.academy.certifications.card.completed');

  TRANSLATED_VIEW = I18n.t('js.academy.certifications.card.view');

  TRANSLATED_FREE = I18n.t('js.academy.certifications.card.free');

  TRANSLATED_PURCHASED = I18n.t('js.academy.certifications.card.purchased');

  TRANSLATED_SOLD_OUT = I18n.t('js.academy.certifications.card.sold_out');

  TRANSLATED_PREVIEW = I18n.t('js.academy.certifications.card.options.preview');

  TRANSLATED_DELETE = I18n.t('js.academy.certifications.card.options.delete');

  TRANSLATED_EDIT_VISIBILITY = I18n.t('js.academy.certifications.card.options.edit_visibility');

  TRANSLATED_EDIT_METADATA = I18n.t('js.academy.certifications.card.options.edit_metadata');

  TRANSLATED_EDIT_CONTENT = I18n.t('js.academy.certifications.card.options.edit_content');

  TRANSLATED_SOLD_OUT_ALERT = I18n.t('js.academy.certifications.card.sold_out_alert');

  state = {
    bannerImage: this.props.certification.bannerImage,
  };

  constructor(props) {
    super(props);
    this.setInstanceVariables = this.setInstanceVariables.bind(this);
    this.setInstanceVariables(props);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    this.setInstanceVariables(this.props);
  }

  render() {
    const { bannerImage } = this.state;

    return this.getCard(bannerImage, this.props.allowEditCard);
  }

  getUrl = () => {
    const { certification, pageSlug } = this.props;
    const urlPrefix = pageSlug ? `/pages/${pageSlug}` : '';

    return certification.shouldAwardCertification
      ? `${urlPrefix}/certifications/${certification.id}`
      : `${urlPrefix}/paths/${certification.id}`;
  };

  getCard = (bannerImage = this.state.bannerImage, isAdmin = false) => {
    const { certification, certificationAssigned, themeOptions, dueAt } = this.props;
    const { badgeImage, description, id, numContent, title } = certification;
    const { currency, amountCents, amountProprietaryCurrency, isSoldOut, shouldAwardCertification } = certification;
    const TRANSLATED_TOTAL_MODULES = I18n.t('js.academy.certifications.card.total_modules', { count: numContent });

    const doesContentHavePrice = EcommerceUtils.doesContentHavePrice(amountCents, amountProprietaryCurrency);
    let formattedPrice = null;
    if (doesContentHavePrice)
      formattedPrice = amountCents
        ? EcommerceUtils.currencyFormatter(currency, amountCents)
        : amountProprietaryCurrency;

    const ecommerceParams = {
      isEcommerceSetUp: this.props.isEcommerceSetUp,
      isSoldOut,
      doesUserNeedToPurchaseContent: this.doesUserNeedToPurchaseContent,
      doesContentHavePrice,
      formattedPrice,
    };

    const TRANSLATED_ASSIGNED = I18n.t('js.academy.content_card.assigned');

    let badgeImageToDisplay;
    if (shouldAwardCertification) {
      badgeImageToDisplay = badgeImage || APP_CONSTANTS.DEFAULT_BADGE_IMAGES.MEDAL.url;
    } else {
      badgeImageToDisplay = badgeImage || APP_CONSTANTS.DEFAULT_BADGE_IMAGES.PATH.url;
    }

    return (
      <AcademyThemeContentCard
        className={this.props.className}
        accentColor={themeOptions.accentColor}
        awardedAt={this.props.awardedAt}
        badge={!bannerImage && badgeImageToDisplay}
        bannerImage={bannerImage}
        cardStyle={themeOptions.cardStyle}
        certification={certification}
        contentLabelOverrides={themeOptions.contentLabelOverrides}
        ecommerceParams={ecommerceParams}
        description={description}
        dueAt={dueAt}
        expiresAt={this.props.expiresAt}
        isAdmin={isAdmin}
        key={id}
        contentId={id}
        metasRight={TRANSLATED_TOTAL_MODULES}
        moreOptions={isAdmin && this.renderMoreOptionsButton()}
        name={title}
        onClick={this.handleCardClick}
        numContent={numContent}
        progressText={this.renderProgressText()}
        progressPercent={this.props.awarded || (this.props.completed && !shouldAwardCertification) ? 100 : 0}
        flagText={certificationAssigned ? TRANSLATED_ASSIGNED : null}
        type={AssetPickerTypes.ACADEMY_CERTIFICATION}
        hasCardMetas
        url={this.getUrl()}
      />
    );
  };

  renderProgressText = () => {
    const { maxPurchaseQuantity, quantityAlreadyPurchased, shouldAwardCertification } = this.props.certification;

    if (this.soldOutAndNeedsUserPurchase) return <div className="progress-text" />;

    let TRANSLATED_NUM_PURCHASED = ' ';
    if (this.doesContentHavePrice) {
      if (maxPurchaseQuantity !== null) {
        TRANSLATED_NUM_PURCHASED = I18n.t('js.academy.certifications.card.num_purchased_with_max', {
          purchased: quantityAlreadyPurchased,
          max_purchase: maxPurchaseQuantity,
        });
      } else {
        TRANSLATED_NUM_PURCHASED = I18n.t('js.academy.certifications.card.num_purchased', {
          purchased: quantityAlreadyPurchased,
        });
      }
    }

    if (this.props.allowEditCard) {
      return <div className="progress-text">{TRANSLATED_NUM_PURCHASED}</div>;
    }

    const text = this.props.awarded || this.props.completed ? this.TRANSLATED_COMPLETED : this.TRANSLATED_VIEW;

    return <div className="progress-text">{text}</div>;
  };

  renderMoreOptionsButton = () => {
    const dropdownButton = (
      <div className="end-user-card--dropdown university-folder-card--dropdown">
        <img src="/images/more_options_icon_card.svg" width="18px" />
      </div>
    );

    return (
      <MoreOptionsWrapper className="end-user-card--more-options-node--2019">
        <Dropdown button={dropdownButton} position={{ top: '30px', right: '0', bottom: 'auto', left: 'auto' }}>
          {this.renderDropdownOptions()}
        </Dropdown>
      </MoreOptionsWrapper>
    );
  };

  renderDropdownOptions = () => {
    const showEditVisibility = isFeatureEnabled('academy_segments') && isFeatureEnabled('academy_segments_certs');

    return (
      <>
        {this.renderPreviewOption()}
        {this.renderEditCertificationMetadata()}
        {this.renderEditCertificationContent()}
        {showEditVisibility && this.renderEditVisibility()}
        {this.renderEditCertificationBannerImage()}
        {this.renderIsFeaturedToggleOption()}
        {this.renderDeleteOption()}
      </>
    );
  };

  updateCertification = async (certification) => {
    const { updateCertificationState } = this.props;
    const { isFeatured, id, shouldAwardCertification } = certification;
    const pathOrCert = shouldAwardCertification ? 'Certification' : 'Path';
    MixPanel.track(window.APP_CONSTANTS.MIXPANEL_TRACKING_KEYS.ACADEMY_ADMIN_TOGGLE_IS_FEATURED_CONTENT, {
      isFeatured,
      content: pathOrCert,
    });
    updateCertificationState({ ...certification, isFeatured: !isFeatured });
    await AcademiesApi.updateCertification(id, { isFeatured: !isFeatured });
  };

  renderIsFeaturedToggleOption = () => {
    const {
      certification,
      themeOptions: { contentLabelOverrides },
    } = this.props;
    const { isFeatured } = certification;
    const toggleText = StringUtils.getAddOrRemoveFeaturedSection(contentLabelOverrides, 'Certifications', isFeatured);
    return (
      <li>
        <a onClick={() => this.updateCertification(certification)}>{toggleText}</a>
      </li>
    );
  };

  renderPreviewOption = () => (
    <li>
      <a onClick={this.previewCertification}>{this.TRANSLATED_PREVIEW}</a>
    </li>
  );

  renderDeleteOption = () => (
    <li>
      <a onClick={this.promptForCertificationDeletion}>{this.TRANSLATED_DELETE}</a>
    </li>
  );

  renderEditVisibility = (e) => (
    <li>
      <a onClick={this.openEditSegmentVisibilityModal}>{this.TRANSLATED_EDIT_VISIBILITY}</a>
    </li>
  );

  renderEditCertificationMetadata = () => (
    <li>
      <a onClick={(e) => this.props.onEditCertification(e, this.props.certification)}>
        {this.TRANSLATED_EDIT_METADATA}
      </a>
    </li>
  );

  renderEditCertificationContent = () => {
    const navToContent = (e) => {
      e.stopPropagation();
      location.href += `/${this.props.certification.id}`;
    };

    return (
      <li>
        <a onClick={navToContent}>{this.TRANSLATED_EDIT_CONTENT}</a>
      </li>
    );
  };

  openEditSegmentVisibilityModal = (e) => {
    e.stopPropagation();

    const segmentsMappedForModal = _.map(this.props.certification.academySegments, (segment) => ({
      id: segment.id,
      label: segment.name,
      value: segment.value,
    }));

    return WRModals.custom(
      EditSegmentVisibilityModal,
      {
        academyId: this.props.academyId,
        hasLoaded: true,
        hasSegments: this.props.hasSegments,
        objectId: this.props.certification.id,
        objectType: AssetPickerTypes.ACADEMY_CERTIFICATION,
        visibleSegments: segmentsMappedForModal,
      },
      (updatedSegments) => {
        const updatedCert = this.props.certification;

        updatedCert.academySegments = _.map(updatedSegments, (updatedSegment) => ({
          id: updatedSegment.id,
          name: updatedSegment.label,
          academyId: this.props.academyId,
        }));

        this.props.updateCertificationState(updatedCert);
      },
    );
  };

  previewCertification = (e) => {
    e.stopPropagation();

    const date = new Date();
    const currentTime = date.getTime();
    const { enterprise } = getCurrentUser();

    const mockAcademyCertificationUser = {
      academyCertification: this.props.certification,
      externalUser: {
        displayName: 'Jane Doe',
        enterprise: {
          displayName: enterprise.friendly_name,
          colorLogo: { url: enterprise.colorLogo },
        },
      },
      awardedAt: currentTime,
    };

    WRModals.custom(AwardedAcademyCertificationModal, {
      academyCertificationUser: mockAcademyCertificationUser,
      isAdminPreview: true,
      themeOptions: this.props.themeOptions,
    });
  };

  promptForCertificationDeletion = (e) => {
    e.stopPropagation();
    this.props.deleteCertification(this.props.certification.id);
  };

  handleCardClick = (e) => {
    if (this.props.allowEditCard) {
      e.preventDefault();
      return false;
    }

    if (this.soldOutAndNeedsUserPurchase) {
      e.preventDefault();
      WRModals.alert(this.TRANSLATED_SOLD_OUT_ALERT);
      return false;
    }
    return window.open(this.getUrl(), '_self');
  };

  setInstanceVariables = (props) => {
    const {
      academyCertificationUser,
      accessibleContentIds,
      allowEditCard,
      certification: { currency, amountCents, id, amountProprietaryCurrency, isSoldOut },
    } = props;

    this.doesUserNeedToPurchaseContent =
      !allowEditCard &&
      !this.props.awarded &&
      (_.isEmpty(accessibleContentIds) ||
        EcommerceUtils.userNeedsToPurchase(id, accessibleContentIds, amountCents, amountProprietaryCurrency));
    this.formattedPrice = amountCents
      ? EcommerceUtils.currencyFormatter(currency, amountCents)
      : amountProprietaryCurrency;
    this.doesContentHavePrice = EcommerceUtils.doesContentHavePrice(amountCents, amountProprietaryCurrency);
    this.soldOutAndNeedsUserPurchase = this.doesUserNeedToPurchaseContent && isSoldOut;
  };

  renderEditCertificationBannerImage = () => (
    <li>
      <a onClick={this.showCertificationBannerImageModal}>Edit Banner Image</a>
    </li>
  );

  showCertificationBannerImageModal = () => {
    const { id } = this.props.certification;

    WRModals.custom(EditCardBannerModal, {
      card: this.getCard,
      editCardBanner: this.editCardBannerCallback,
      cardBannerUploadUrl: AcademyCertification.bannerUploadUrl(id),
      defaultCoverForType: APP_CONSTANTS.DEFAULT_COVER_IMAGES.SERIES,
      cardWrapperStyle: {
        padding: '35px 20%',
      },
    });
  };

  editCardBannerCallback = (imgUrl = null, cb = null) => {
    const data = { remote_banner_image_url: imgUrl };

    showLoader();
    apiPut(
      `academy_certifications/${this.props.certification.id}`,
      data,
      (updatedCertification) => {
        hideLoader();
        this.setState({
          bannerImage: updatedCertification.bannerImage,
        });
        if (cb) cb(null, updatedCertification.bannerImage);
      },
      handleApiError(),
    );
  };
}

const MoreOptionsWrapper = styled.div`
  cursor: pointer;
  right: 0;
  border-top-right-radius: 6px;
  z-index: 1;
`;

export default AcademyCertificationCard;
